import { useMutation } from "@tanstack/react-query";
import { api } from "shared/api";

const fetchPaymentMethods = async () => {
  const res = await api().gersGetPaymentMethods();
  return res.data;
};

export const usePanelPaymentMethods = () => useMutation(fetchPaymentMethods);
